import React, { useState, useEffect, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  Form
} from "reactstrap";
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { callAPI } from "../../_helper/index";
import { toast } from "react-toastify";
import PlacesAutocomplete, {
  geocodeByAddress
} from "react-places-autocomplete";
import { useForm } from "react-hook-form";
import Select from "react-dropdown-select";
import { Spinner } from 'reactstrap';
var $ = require("jquery");
function ManageOrder() {
  const { id } = useParams();
  const timeoutRef = useRef(null)
  const [order, setOrder] = useState({
    Id: 0,
    OrderNumber: "",
    FirstName: "",
    LastName: "",
    Address: "",
    City: "",
    State: "",
    Zip: "",
    ContactNumber: "",
    Lat: "",
    Long: "",
  });
  const [address, setAddress] = useState("");
  const history = useHistory();
  const { register, errors, handleSubmit } = useForm()
  const [IsLoading, setIsLoading] = useState(false)
  useEffect(() => {
    if (id) {
      loadOrder();
    }
  }, []);

  const loadOrder = () => {
    var response = callAPI(`/api/orders/${id}/0`, "GET", null);
    response.then((res) => {
      if (res.success) {

        setOrder(res.data[0]);
        setAddress(res.data[0].Address)
      } else {
        toast.error(res.message);
      }
    });
  };




  useEffect(() => {
    clearInterval(timeoutRef.current)
    if (order.FirstName != '' && order.LastName != '' && order.ContactNumber != '') {
      let data = {
        FirstName: order.FirstName,
        LastName: order.LastName,
        ContactNo: order.ContactNumber
      }


      timeoutRef.current = setTimeout(() => {
        var response = callAPI(`/api/order-address`, "POST", JSON.stringify(data));
        response.then((res) => {
      
          if (res.success && res.data.length > 0) {
            setOrder({ ...order, ...res.data[0] });
            setAddress(res.data[0].Address)
          }
        });
      }, 3000);


    }


  }, [order.FirstName, order.LastName, order.ContactNumber]);


  const onInputChange = (e) => {
    setOrder({ ...order, [e.target.name]: e.target.value });
  };



  const formRef = useRef(null)
  const handleChange = (address) => {
    setAddress(address);
  };

  const handleSelect = (address) => {

    geocodeByAddress(address)
      .then((results) => {
        debugger
        var geoMatry = results[0];
        setAddress(geoMatry.formatted_address)
        setOrder((prevState) => {
          return { ...prevState, Address: geoMatry.formatted_address };
        });
        var addressComponent = geoMatry.address_components;
        if (addressComponent.length > 0) {
          addressComponent.map((address) => {
            if (address.types.indexOf("postal_code") >= 0) {
              setOrder((prevState) => {
                return { ...prevState, Zip: address.short_name };
              });
            } else if (
              address.types.indexOf("administrative_area_level_1") >= 0
            ) {
              setOrder((prevState) => {
                return { ...prevState, State: address.short_name };
              });
            } else if (address.types.indexOf("locality") >= 0) {
              setOrder((prevState) => {
                return { ...prevState, City: address.short_name };
              });
            }
          });
        }
        setOrder((prevState) => {
          return { ...prevState, Lat: geoMatry.geometry.location.lat() };
        });
        setOrder((prevState) => {
          return { ...prevState, Long: geoMatry.geometry.location.lng() };
        });
        //getLatLng(results[0])
      })
      .catch((error) => {
        console.error("Error", error);
      });
  };


  const onSubmit = () => {
    setIsLoading(true)
    var response = callAPI(`/api/orders`, "POST", JSON.stringify(order));
    response.then((res) => {
      if (res.success) {
        toast.success("Order saved!!!");
        setTimeout(() => {
          setIsLoading(false)
          history.push("/admin/order");
        }, 1000);
      } else {
        setIsLoading(false)
        toast.error(res.message);
      }
    });
  }
  const handleClick = (e) => {
    e.preventDefault();
    formRef.current.props.onSubmit()
  };



  return (
    <>
      <PanelHeader size="lg" />
      {
        IsLoading &&
        <div className="loader">
          <Spinner color="white" />
        </div>
      }
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <Card className="card-chart">
              <CardHeader>
                {/* <CardTitle tag="h4">Order Management</CardTitle> */}
              </CardHeader>
              <CardBody>
                <Form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                  <div className="new_user">
                    <h5>Receiver Information</h5>
                    <input type="hidden" name="Id" value={order.Id} />
                    <Row>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="fname" className="text-dark">
                            First Name:
                          </label>
                          <Input
                            type="text"
                            name="FirstName"
                            value={order.FirstName}
                            className="form-control"
                            placeholder="John"
                            onChange={(e) => onInputChange(e)}
                            innerRef={register({ required: true })}
                            invalid={errors.FirstName && true}
                          />
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="lname" className="text-dark">
                            Last Name:
                          </label>
                          <Input
                            type="text"
                            name="LastName"
                            value={order.LastName}
                            className="form-control"
                            placeholder="Mark"
                            onChange={(e) => onInputChange(e)}
                            innerRef={register({ required: true })}
                            invalid={errors.LastName && true}
                          />
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="ContactNumber" className="text-dark">
                            Contact Number:
                          </label>
                          <Input
                            id="numberinput"
                            type="number"
                            name="ContactNumber"
                            value={order.ContactNumber}
                            className="form-control"
                            placeholder="9876543210"
                            onChange={(e) => onInputChange(e)}
                            innerRef={register({ required: true })}
                            invalid={errors.ContactNumber && true}
                          />
                        </div>
                      </Col>

                    </Row>
                    <h5>Billing Information</h5>
                    <Row>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="Address" className="text-dark">
                            Address:
                          </label>
                          <PlacesAutocomplete
                            value={address}
                            onChange={(e) => handleChange(e)}
                            onSelect={(e) => handleSelect(e)}
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div>
                                <Input
                                  name="address"
                                  {...getInputProps({
                                    placeholder: "Search Places ...",
                                    className:
                                      "location-search-input form-control",
                                  })}
                                  innerRef={register({ required: true })}
                                  invalid={errors.address && true}
                                />
                                <div className="autocomplete-dropdown-container">
                                  {suggestions.map((suggestion) => {
                                    const className = suggestion.active
                                      ? "suggestion-item--active"
                                      : "suggestion-item";
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                      ? {
                                        backgroundColor: "#fafafa",
                                        cursor: "pointer",
                                        padding: "5px",
                                      }
                                      : {
                                        backgroundColor: "#ffffff",
                                        cursor: "pointer",
                                        padding: "5px",
                                      };
                                    return (
                                      <div
                                        {...getSuggestionItemProps(suggestion, {
                                          className,
                                          style,
                                        })}
                                      >
                                        <span>{suggestion.description}</span>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                          {/* <input
                            type="text"
                            name="Address"
                            value={order.Address}
                            className="form-control"
                            placeholder="123 street"
                            onChange={(e) => onInputChange(e)}
                          /> */}
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="City" className="text-dark">
                            City:
                          </label>
                          <Input
                            type="text"
                            name="City"
                            value={order.City}
                            className="form-control"
                            placeholder="Auburn"
                            onChange={(e) => onInputChange(e)}
                            innerRef={register({ required: true })}
                            invalid={errors.City && true}
                          />
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="State" className="text-dark">
                            State:
                          </label>
                          <Input
                            type="text"
                            name="State"
                            value={order.State}
                            className="form-control"
                            placeholder="CA"
                            onChange={(e) => onInputChange(e)}
                            innerRef={register({ required: true })}
                            invalid={errors.State && true}
                          />
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="Zip" className="text-dark">
                            Zip:
                          </label>
                          <Input
                            type="text"
                            name="Zip"
                            value={order.Zip}
                            className="form-control"
                            placeholder="12345"
                            onChange={(e) => onInputChange(e)}
                            innerRef={register({ required: true })}
                            invalid={errors.Zip && true}
                          />
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="Lat" className="text-dark">
                            Lat:
                          </label>
                          <Input
                            type="text"
                            name="Lat"
                            value={order.Lat}
                            className="form-control"
                            placeholder="21.1710216"
                            onChange={(e) => onInputChange(e)}
                            innerRef={register({ required: true })}
                            invalid={errors.Lat && true}
                          />
                        </div>
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="Long" className="text-dark">
                            Long:
                          </label>
                          <Input
                            type="text"
                            name="Long"
                            value={order.Long}
                            className="form-control"
                            placeholder="72.7775804"
                            onChange={(e) => onInputChange(e)}
                            innerRef={register({ required: true })}
                            invalid={errors.Long && true}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="form-group">
                      <Button
                        type="button"
                        onClick={(e) => handleClick(e)}
                        className="btn btn-info"
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ManageOrder;
